import { render, staticRenderFns } from "./dataSize.vue?vue&type=template&id=1dae8c6e&scoped=true"
import script from "./dataSize.vue?vue&type=script&lang=js"
export * from "./dataSize.vue?vue&type=script&lang=js"
import style0 from "./dataSize.vue?vue&type=style&index=0&id=1dae8c6e&prod&lang=css"
import style1 from "./dataSize.vue?vue&type=style&index=1&id=1dae8c6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dae8c6e",
  null
  
)

export default component.exports